import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Filter from "./common/filter";
import ProductListing from "./common/product-listing";
import StickyBox from "react-sticky-box";
import "../common/index.scss";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { addToWishlist } from '../../actions/wishlist';
import { getCategoryItems } from "../../actions/category";
import {restFilters, getAllFilters} from '../../actions/filters';
import FilterBar from "./common/filter-bar";
import Sidebar from "react-sidebar";
import {filterDefault} from '../common/MangoIcons'
import {funnelDefault} from '../common/MangoIcons'
import { toast } from 'react-toastify';
import queryString from 'query-string'
import Select from 'react-dropdown-select';




export const defaultFilter = {
  location: "all_store",
  brand_code: [],
  gender_id: [],
  //collection_id: "",
  new_arrivals: "",
  price_start_range: "",
  price_end_range: "",
  size_id: [],
  color_id: [],
  page: "",
};

class Collection extends Component {
  constructor() {
    super();
    this.state = {
      layoutColumns: 6,
      limit: 1000,
      hasMoreItems: false,
      ...defaultFilter,
      sidebarOpen: false,
      sortBy : 0,
      sideBarOption : 'Left', 
      currentPage: 1,
    nextDisabled: false,
    prevDisabled: true,
     color_code: '', 
      size_id: '',
      purity_id:'',
      price_start_range: '',
      price_end_range: '',
       isLoading: false,
      matches: window.matchMedia("(max-width: 768px)").matches
    };
    this.onSetSidebarOpen = this.onSetSidebarOpen.bind(this);
    this.onSetSidebarOpen1 = this.onSetSidebarOpen1.bind(this);
  }

  LayoutViewClicked(colums) {
    this.setState({
        layoutColumns:colums
    })
}


    onSetSidebarOpen(open) {
      
      if(open){
        document.getElementById('root').style.position = "fixed";
        document.getElementById('root').style.width = "100%";
        document.getElementById('root').style.height = "100%";
      } else {
       //  
        document.getElementById('root').style.position = "";
        document.getElementById('root').style.height = "";
      }
      this.setState({ sidebarOpen: open });
    }

    //
    onSetSidebarOpen1(open) {
      
      if(open){
        document.getElementById('root').style.position = "fixed";
        document.getElementById('root').style.width = "100%";
        document.getElementById('root').style.height = "100%";
      } else {
       //  
        document.getElementById('root').style.position = "";
        document.getElementById('root').style.height = "";
      }
      this.setState({ sidebarOpen: open });
    }

  openFilter = () => {
    document.querySelector(".collection-filter").style = "left: -15px";
  };

  async componentDidMount() {
    const { connection_id, store_id ,display_limit} = this.props;
    console.log(display_limit,'display_limit')
    const category_id = this.props.categoryId;
    const cat_level1 = this.props.cat_level1;
    const cat_level2 = this.props.cat_level2;
    const cat_level3 = this.props.cat_level3;
    const cat_level4 = this.props.cat_level4;
    const cat_level5 = this.props.cat_level5;
    const values = queryString.parse(this.props.location.search)

    
    this.props.restFilters();
    const options = {
      connection_id : this.props.connection_id,
      category_id : this.props.categoryId,
      brand_code : this.props.brandCode,
      gender_id: [],
      category_level_1 : cat_level1|"",
      category_level_2 : cat_level2|"",
      category_level_3 : cat_level3|"",
      category_level_4 : cat_level4|"",
      category_level_5 : cat_level5|"",
      tenant_name:this.props.tenant_name,
      


    }
    this.props.getAllFilters(options);
    if (values.filter){
        this.setState({
          gender_id: [values.filter]
        }, async () => {
        await   this.props.getCategoryItems({
            ...this.state,
            category_id: (this.props.categoryId && this.props.categoryId).split(","), 
      brand_code : (this.props.brandCode).split(","),
      tenant_name:this.props.tenant_name,

            ...{ connection_id, store_id },
            page : 1
          });
        })
    }
     else {
     await this.props.getCategoryItems({
        ...this.state,
        category_id: this.props.categoryId.split(","),
      brand_code : (this.props.brandCode).split(","),
      tenant_name:this.props.tenant_name,

        ...{ connection_id, store_id },
        page : 1
      });

     }
     if(this.props.products && this.props.products.length < display_limit){
      this.setState({
    prevDisabled: true,
    nextDisabled: this.props.products.length < display_limit
});
     }else { 
      this.setState({
       prevDisabled : true,
       nextDisabled: false

      })
     }

     if(this.state.matches === true){
       this.setState({
        sideBarOption: 'No'
       })
     }
 
  }

  componentDidUpdate(prevProps) {
    const { connection_id, store_id , categoryId} = this.props;
    const values = queryString.parse(this.props.location.search)
    if (this.state.gender_id[0] !== values.filter) {
      this.setState({
        gender_id: [values.filter]
      },  () => {
        this.props.getCategoryItems({
          ...this.state,
          category_id: categoryId.split(","),
      brand_code : (this.props.brandCode).split(","),
      tenant_name:this.props.tenant_name,

          ...{ connection_id, store_id },
          page : 1
        });
      })
    }
  }
  componentWillReceiveProps(nextProps) {
    const { connection_id, store_id } = this.props;
    const values = queryString.parse(this.props.location.search)
   
    let nextPropsGenderId = nextProps.location.search.slice(-2);
    let PropsGenderId = this.props.location.search.slice(-2);
    if (nextProps.match.params.id !== this.props.match.params.id) {
      const category_id = nextProps.match.params.id;
      
      this.props.restFilters()
      const options = {
        connection_id : this.props.connection_id,
        category_id : nextProps.match.params.id,
        brand_code : nextProps.match.params.id1,
        gender_id: [],
        category_level_1 : nextProps.match.params.id1|"",
        category_level_2 : nextProps.match.params.id2 |"",
        category_level_3 : nextProps.match.params.id3 |"",
        category_level_4 : nextProps.match.params.id4 |"",
        category_level_5 : nextProps.match.params.id5 |"",
         tenant_name:this.props.tenant_name
  
  
      }
      this.props.getAllFilters(options);
      if (values.filter){
        if(PropsGenderId === nextPropsGenderId){
        this.setState({
          gender_id: [values.filter]
        },  () => {
          this.props.getCategoryItems({
            ...this.state,
            category_id: category_id.split(","),
      brand_code : (this.props.brandCode).split(","),
      tenant_name:this.props.tenant_name,

            ...{ connection_id, store_id },
            page:1
          });
        })
      }
    }
     else {
      this.props.getCategoryItems({
        ...this.state,
        category_id: category_id.split(","),
      brand_code : (this.props.brandCode).split(","),
      tenant_name:this.props.tenant_name,

        ...{ connection_id, store_id },
        page:1
      });
     }
    }
    if (nextProps.store_id !== this.props.store_id) {
      const category_id = this.props.categoryId;
      this.props.restFilters()
      const options = {
        connection_id : this.props.connection_id,
        category_id : this.props.categoryId,
        brand_code : this.props.brandCode,
        gender_id: values.filter,
        category_level_1 : this.props.cat_level1|"",
        category_level_2 : this.props.cat_level2 | "",
        category_level_3 : this.props.cat_level3 | "",
        category_level_4 : this.props.cat_level4 | "",
        category_level_5 : this.props.cat_level5 | "",
         tenant_name:this.props.tenant_name
  
  
      }
      this.props.getAllFilters(options);
      
      if (values.filter){
        this.props.getCategoryItems({
          ...this.state,
                brand_code : (this.props.brandCode).split(","),

          gender_id: [values.filter],
          tenant_name:this.props.tenant_name,
          price_start_range: '',
          price_end_range: '',
          category_id: category_id.split(","),
          ...{ connection_id, store_id },
          page:1
        });
      } else  {
        this.props.getCategoryItems({
          ...this.state,
                brand_code : (this.props.brandCode).split(","),

          gender_id: "",
          price_start_range: '',
          price_end_range: '',
          tenant_name:this.props.tenant_name,
          category_id: category_id.split(","),
          ...{ connection_id, store_id },
          page:1
        });
      }



    }
  }


  fetchMoreItems = () => {
    if (this.state.limit >= this.props.count) {
      this.setState({ hasMoreItems: false });
      return;
    }
    // this.setState({page: this.state.page + 1})
    // const connection_id = process.env.REACT_APP_CONNECTION_ID
    // const bar_code = ""
    // const category_id =  this.props.categoryId
    // this.props.getMoreCollectionItems({...this.state,...{connection_id, bar_code, category_id}})
    setTimeout(() => {
      this.setState({
        limit: this.state.limit + 12,
      });
    }, 500);
  };

  applyFilter = async(filters) => {
    // 
    const { connection_id, store_id ,display_limit} = this.props;
    const category_id = this.props.categoryId;
    // 
    //   ...this.state,
    //   ...filters,
    //   ...{ connection_id, category_id, store_id }
    // });
    await this.props.getCategoryItems({
      ...this.state,
      brand_code: filters.selectedBrands,
      gender_id: this.state.gender_id || '',
      color_code: filters.selectedColors, 
      size_id: filters.selectedSizes,
      purity_id:filters.selectedPurities,
      price_start_range: filters.value.min,
      price_end_range: filters.value.max,
      category_id: category_id.split(","),
      tenant_name:this.props.tenant_name,
      ...{ connection_id, store_id },
      page : 1
    });
    this.setState({
       color_code: filters.selectedColors, 
      size_id: filters.selectedSizes,
      purity_id:filters.selectedPurities,
      price_start_range: filters.value.min,
      price_end_range: filters.value.max,
       currentPage: 1,
        prevDisabled:  true,
        nextDisabled: this.props.products.length < display_limit
    })
    this.onSetSidebarOpen(false)
  }

  handleAddToWishlist = (item) => {
    if (!this.props.isAuth) {
      toast.success("Please login / Register to add items to Wishlist.");
      this.props.history.push(`/login`)
      // this.props.history.goBack()
  } else {
    const {connection_id, consumer_mobile_no} = this.props
    const options = { connection_id, consumer_mobile_no, lot_code: item.QOL_LOT_CD }
    this.props.addToWishlist(options)
  }
}
handleSortBy=(value) => {
  this.setState({
    sortBy : value[0].value
  })
  

}
getPageData = async (page) => {

    const { connection_id, store_id,display_limit } = this.props;

    await this.props.getCategoryItems({
        ...this.state,
        category_id: this.props.categoryId.split(","),
        brand_code: this.props.brandCode.split(","),
        tenant_name: this.props.tenant_name,
        connection_id,
        store_id,
        page: page
    });

    this.setState({
        currentPage: page,
        prevDisabled: page === 1,
        nextDisabled: this.props.products.length < display_limit
    });
};
// handlePrevious = async () => {

//     if (this.state.currentPage <= 1) return;

//     await this.getPageData(this.state.currentPage - 1);
// };
// handleNext = async () => {

//     if (this.state.nextDisabled) return;

//     await this.getPageData(this.state.currentPage + 1);
// };

handlePrevious = async () => {

    if (this.state.isLoading || this.state.prevDisabled) return;

    this.setState({ isLoading: true });

    try {
        await this.getPageData(this.state.currentPage - 1);
    } finally {
        this.setState({ isLoading: false });
    }
};

handleNext = async () => {

    if (this.state.isLoading || this.state.nextDisabled) return;

    this.setState({ isLoading: true });

    try {
        await this.getPageData(this.state.currentPage + 1);
    } finally {
        this.setState({ isLoading: false });
    }
};
  render() {
    const { products, loading, categoryId } = this.props;
    
    const { sideBarOption } = this.state;
    const sortByList = [
      { label: "Sort By Price: low to high", value: 1 },
       { label: "Sort By Price: high to low", value: 2 }
      /*{ label: "Sort By Popularity", value: 3 } */
    ];
    
    return (
      <div>
        {/*SEO Support*/}
        <Helmet>
          <title>{this.props.customer_name} | Collections </title>
          <meta name="description" content="" />
        </Helmet>
        {/*SEO Support End */}

        {/* <Breadcrumb title={'Collection'}/> */}

        <section className="section-b-space" style={{paddingTop:30}}>
        <div className="collection-page-title" style={window.innerWidth > 567 ? {position:"absolute",marginLeft:'50%',marginTop:'1%'}:{paddingBottom:'20px'}}>
          {loading ? 'Loading.. please wait' : products && products.length > 0 && products.map((p,idx) => {if(p.SKU_HNODE == categoryId && idx == 0) return p.SKU_HNODE_DESC })}
          </div>
          
          <div className="collection-wrapper" style={{marginBottom:60}}>
            <div className="container">
              <div className="row">
             
             
                  {/* <StickyBox offsetTop={0} offsetBottom={20}>
                    <Filter
                      handleApplyFilters={this.applyFilter}
                      categoryId={this.props.categoryId}
                    />
                  </StickyBox> */} 

                   {/* No Sidebar */}

                   {sideBarOption === 'No' &&
                   <Sidebar
                    sidebar={ <Filter
                      handleApplyFilters={this.applyFilter}
                      categoryId={this.props.categoryId}
                      onSetSidebarOpen={this.onSetSidebarOpen}
                      sideBarOption={sideBarOption}
                    />}
                    open={this.state.sidebarOpen}
                    touch={false}
                    rootClassName={"filter-panel-left"}
                    sidebarClassName={"filter-side-bar"}
                    overlayClassName={"filter-overlay"}
                    onSetOpen={this.onSetSidebarOpen}
                    styles={{ sidebar: { background: "white" } }}
                  ><div/></Sidebar>
                    }
                  {/* No Sidebar */}


                  {/* Left Sidebar */}
                  {sideBarOption === 'Left' && 
                  <div className="col-sm-3">
                  <Filter
                    handleApplyFilters={this.applyFilter}
                    categoryId={this.props.categoryId}
                    onSetSidebarOpen={this.onSetSidebarOpen}
                    sideBarOption={sideBarOption}
                    dataLoad={this.props.loading}
                  />
                  </div>
                  }

                  {/* end Left Sidebar */}
               
                <div className="collection-content col">
                  <div className="page-main-content ">
                    <div className="">
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="collection-product-wrapper">


                            {/* No Sidebar */}
                            
                            <div className="" >
                              <div className="container-fluid p-0">
                                <div className="row justify-content-between">
                                  <div className="col-lg-6">
                                    {/* <div className="filter-main-btn"> */}
                                      {/* <span
                                        // onClick={this.openFilter}
                                        onClick={() => this.onSetSidebarOpen(true)}
                                        className="filter-btn btn btn-theme"
                                      >
                                        <i
                                          className="fa fa-filter"
                                          aria-hidden="true"
                                        />{" "}
                                        Filter
                                      </span> */}
                                    {/* </div> */}
                                      {sideBarOption === 'No' &&
                                      <img src={filterDefault} onClick={() => this.onSetSidebarOpen(true)} style={{cursor: "pointer"}}/>
                                      }
                                      
                                      </div>
                               
                                    <div className="col-lg-6 d-none d-lg-inline-block" style={{textAlign: "right"}}>
                                        <FilterBar 
                                        colSize={this.state.layoutColumns}
                                        onLayoutViewClicked={(colmuns) => this.LayoutViewClicked(colmuns)}/>
                                    </div>
                                   
                                </div>
                              </div>
                            </div>
                           
                            <div className='container category-select'>
                            
                            <div className='row' >
                            <div className='col' style={{paddingLeft:14,paddingTop:10,paddingRight:0}}>
                              <div style={window.innerWidth > 567 ? {float:"right",width:'43%',paddingTop:45} : {}}>
                            <Select options={sortByList} placeholder={"Select Sort By"}  className={"reactDropdownStyle1"} 
                        onChange={(value) => this.handleSortBy(value)}
                        /></div>
                              </div></div></div>

                            {/* End No Sidebar */}

                            
                            {/*Products Listing Component*/}
                            <ProductListing
                              colSize={this.state.layoutColumns}
                              sortBy = {this.state.sortBy}
                              loading={this.state.loading}
                              error={this.state.error}
                              limit={this.state.limit}
                              hasMoreItems={this.state.hasMoreItems}
                              fetchMoreItems={this.fetchMoreItems}
                              addToWishlistClicked={this.handleAddToWishlist}
                            />
                          </div>
                          { products && products.length > 0 && ! loading? 
                            <div className="text-center" style={{ marginTop: 20 }}>

    <button
        className="btn btn-secondary"
        disabled={this.state.prevDisabled || this.state.isLoading}
        onClick={this.handlePrevious}
        style={{backgroundColor:'#001e63',borderRadius:'30px',cursor: this.state.prevDisabled || this.state.isLoading ? 'default' : 'pointer'}}
    >
        &lt;
    </button>

    <span style={{ margin: "0 5px",background :'#e5e5e5',padding:'8px 24px',borderRadius : '20px', }}>
         
         {this.state.currentPage}
    </span>

    <button
        className="btn btn-primary"
        disabled={this.state.nextDisabled || this.state.isLoading}
        onClick={this.handleNext}
       style={{backgroundColor:'#001e63',borderRadius:'30px',cursor: this.state.nextDisabled || this.state.isLoading ? 'default' : 'pointer'}}

    >
        &gt;
    </button>

</div> : ''}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  products: state.category.products,
  symbol: state.data.symbol,
  categoryType: ownProps.match.params.type,
  categoryId: ownProps.match.params.id,
  brandCode:ownProps.match.params.ids,
  cat_level1 : ownProps.match.params.id1,
  cat_level2 : ownProps.match.params.id2,
  cat_level3 : ownProps.match.params.id3,
  cat_level4 : ownProps.match.params.id4,
  cat_level5 : ownProps.match.params.id5,
  loading: state.category.loading,
  error: state.category.error,
  filters: state.filters,
  store_id: state.store.selectedStore && state.store.selectedStore.ASM_ASSOC_CD,
  count: state.category.count,
  connection_id: state.tenant.connection_id,
  consumer_mobile_no: state.user.user_details && state.user.user_details.COM_CONSUMER_MOBILE_NO,
  isAuth: state.user.isAuth,
  customer_name: state.tenant.tenant_details.STE_ECOM_BRAND_NAME || "",
  tenant_name: state.tenant.store_details.tenant_name || "",
  display_limit : state.tenant.store_details.display_limit || 20,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getCategoryItems,
      getAllFilters,
      restFilters,
      addToWishlist: addToWishlist,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Collection);
